import { HttpClient } from "@angular/common/http";
import { LeadingComment } from "@angular/compiler";
import { Assignment, Shift } from "@apaq/orgkit-js";
import { GeoJsonObject } from "geojson";
import { DataSource } from "./work-plan-map/work-plan-map.component";

interface Leg {
  distance: number;
  duration: number;
}

interface Route extends GeoJSON.Feature {
  duration: number;
  distance: number;
  weight: number;
  weight_name: string;
  legs: Leg[];
}

interface Waypoint {
  distance: number;
  hint: string;
  location: number[];
  name: string;
}

interface OsrmResponse {
  code: string,
  routes: Route[];
  waypoints: any[];
}

export class MapDatasource implements DataSource {
  private osrmResponse?: OsrmResponse;
  private _locations?: number[][] = [];

  private callback?: () => void;

  constructor(private http: HttpClient) {}

  async loadRoute(assignments: Assignment[], shift: Shift) {
    const locations: number[][] = [];

    locations.push(shift.startPoint.location);
    assignments.filter(a => !a.plan.allDay && a.action !== 'Skipped').forEach(a => locations.push(a.location));
    locations.push(shift.endPoint.location);
    this._locations = locations;

    // TODO: Move host into settings
    const url = new URL(`https://geo.previsto.io/route/v1/driving/${locations.map(l => l.join(',')).join(';')}`);
    const params = new URLSearchParams();
    url.searchParams.append('continue_straight', 'false');
    url.searchParams.append('geometries', 'geojson');
    url.searchParams.append('overview', 'full');

    this.osrmResponse = await this.http.get<OsrmResponse>(url.toString()).toPromise();
    this.osrmResponse.routes[0].type = 'Feature';

    if(this.callback != null) {
      this.callback();
    }
  }

  get duration(): number {
    return this.osrmResponse?.routes[0].duration ?? 0;
  }

  get distance(): number {
    return this.osrmResponse?.routes[0].distance ?? 0;
  }

  get distanceOut() {
    let result = 0;
    const route = this.osrmResponse?.routes[0];
    if(route?.legs?.length ?? 0 > 0) {
      result = route!.legs[0].distance;
    }
    return result;
  }

  get distanceBetween() {
    let result = 0;
    const route = this.osrmResponse?.routes[0];
    if(route?.legs?.length ?? 0 > 2) {
      for(let i = 1;i<route!.legs.length-1;i++) {
        result += route!.legs[i].distance;
      }
    }
    return result;
  
  }

  get distanceHome() {
    let result = 0;
    const route = this.osrmResponse?.routes[0];
    if(route?.legs?.length ?? 0 > 1) {
      result = route!.legs[route!.legs.length-1].distance;
    }
    return result;
  
  }

  get locations(): number[][] {
    return this._locations!;
  }

  get route(): GeoJsonObject | undefined {
    return this.osrmResponse?.routes[0] ?? undefined;
  }

  onRouteChanged(callback: () => void): void {
    this.callback = callback;
  }

}
